import React, { Component } from 'react'

class SvgFile extends Component {
  static defaultProps = {
    width: 48,
    height: 48,
    fill: '#CAE9FF'
  }
  render() {
    const { width, height, fill } = this.props
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 48 48"
      >
        <g fill={fill} fillRule="evenodd">
          <path d="M17.999 18.034a.94.94 0 0 0 0 1.326.933.933 0 0 0 1.323 0 .938.938 0 0 0 0-1.326.935.935 0 0 0-1.323 0z" />
          <path d="M33.796 29.885l.942-2.2a.939.939 0 0 0-.181-1.015l-2.314-2.444 14.824-14.104a2.81 2.81 0 0 0 .785-2.557 9.537 9.537 0 0 0-7.495-7.51 2.798 2.798 0 0 0-2.552.787L23.946 15.464 10.102.842l-.017-.018A2.798 2.798 0 0 0 7.55.055a9.516 9.516 0 0 0-4.882 2.618A9.547 9.547 0 0 0 .055 7.565a2.819 2.819 0 0 0 .785 2.557l14.829 14.095-2.32 2.454a.939.939 0 0 0-.18 1.014l.94 2.2L.823 43.199A2.796 2.796 0 0 0 0 45.188c0 .751.292 1.457.822 1.988.53.532 1.235.824 1.985.824s1.455-.292 1.985-.824L18.08 33.863l2.196.943a.931.931 0 0 0 1.012-.18l2.667-2.532 2.663 2.53a.935.935 0 0 0 1.012.182l2.196-.943 13.289 13.313c.53.532 1.235.824 1.984.824.75 0 1.455-.292 1.985-.824.53-.53.822-1.237.822-1.988 0-.751-.292-1.458-.822-1.989L33.796 29.885zm-2.12 3.18c.111-.053.218-.113.32-.18a.93.93 0 0 0 .825-.826 2.8 2.8 0 0 0 .18-.32l9.982 10.003-1.323 1.325-9.984-10.002zm7.476-30.922a.932.932 0 0 1 .838-.25 7.67 7.67 0 0 1 6.027 6.04.936.936 0 0 1-.249.839L30.955 22.866l-5.719-6.04L39.152 2.143zM17.026 25.507l2.104 2-2.8 2.806-1.2-2.8 1.896-2.006zm-10.78 17.56l-1.322-1.325 9.982-10.003a2.8 2.8 0 0 0 .18.32.934.934 0 0 0 .824.826c.102.067.21.127.32.18L6.247 43.067zm-2.778 2.784a.929.929 0 0 1-.661.274.928.928 0 0 1-.661-.275.932.932 0 0 1-.274-.662c0-.25.097-.486.274-.663L3.6 43.067l1.323 1.326-1.455 1.458zm16.98-13.011l-2.795-1.201 2.835-2.841 2.107 2.003-2.147 2.039zm7.011 0L17.635 23.5 2.138 8.771a.932.932 0 0 1-.248-.838A7.677 7.677 0 0 1 3.99 3.999a7.652 7.652 0 0 1 3.926-2.105.933.933 0 0 1 .837.249l24.021 25.37-1.198 2.8-9.608-9.627a.935.935 0 0 0-1.324 0 .939.939 0 0 0 0 1.326l9.609 9.627-2.795 1.2zm18.302 13.01a.929.929 0 0 1-.662.275.928.928 0 0 1-.66-.275l-1.456-1.457 1.323-1.326 1.455 1.458a.932.932 0 0 1 .274.663c0 .25-.098.485-.274.663z" />
          <path d="M23.953 36.188c-3.095 0-5.614 2.523-5.614 5.625 0 3.101 2.519 5.625 5.614 5.625 3.096 0 5.614-2.524 5.614-5.625 0-3.102-2.518-5.625-5.614-5.625zm0 9.375a3.75 3.75 0 0 1 0-7.5 3.75 3.75 0 0 1 0 7.5z" />
        </g>
      </svg>
    )
  }
}

export default SvgFile



// WEBPACK FOOTER //
// ./src/Icons/CompeteWithYourFriends/SvgFile.js